function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M817.9 108.4h-28v687.901c0 45.699-37.2 82.898-82.899 82.898H197.7v25.5c0 29.201 23.7 52.9 52.9 52.9h567.2c29.2 0 52.899-23.699 52.899-52.9V161.3c.001-29.2-23.599-52.9-52.799-52.9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M423.3 849.199h283.6c29.2 0 52.9-23.699 52.9-52.898V52.9c0-29.2-23.7-52.9-52.9-52.9H329v17.5c.199 1.8.3 3.7.3 5.6V168c0 41.1-33.4 74.5-74.5 74.5H109.9c-1.5 0-3.1-.1-4.6-.2H86.9v554.001c0 29.199 23.7 52.898 52.9 52.898h283.5zM434 669.4H249.1c-13.8 0-25-11.201-25-25 0-13.801 11.2-25 25-25h185c13.8 0 25 11.199 25 25 0 13.799-11.3 25-25.1 25zm185-127.599H249.1c-13.8 0-25-11.201-25-25 0-13.801 11.2-25 25-25H619c13.8 0 25 11.199 25 25 0 13.799-11.2 25-25 25zM249.1 356.3H619c13.8 0 25 11.2 25 25s-11.2 25-25 25H249.1c-13.8 0-25-11.2-25-25s11.2-25 25-25z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M109.9 212.5h145.3c24.2-.2 43.8-19.8 44-44V23.1c0-13.4-11-22.3-22.399-22.3-5.5 0-11 2-15.6 6.6L94.1 174.5c-14 14-4.1 38 15.8 38z"
});

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 957.599 957.6",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFile;